import React from 'react';
import Header from "../../Layouts/Header";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import API from "../../Services/API";
import {toast} from "react-toastify";
import {useNavigate, useParams} from "react-router-dom";

import {FaFileSignature} from "react-icons/fa";
import {IoMdClock} from "react-icons/io";
import {IoQrCodeOutline} from "react-icons/io5";
import {HiMiniCalendarDateRange} from "react-icons/hi2";
import {ImLocation} from "react-icons/im";
import {MdEmail} from "react-icons/md";
import {FiExternalLink} from "react-icons/fi";
const Request = () => {
    const navigate = useNavigate();
    const {id} = useParams();
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [request, setRequest] = React.useState([]);

    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            navigate('/login');
        }
        const params = {
            'list' : 0
        }
        API.getRequest(id,params)
            .then((response) => {
                setRequest(response.data);
                setIsLoaded(true)

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                    setTimeout(() => {
                         window.history.back()
                    }, 400)
                } else {
                    toast.error(error.message);
                    setTimeout(() => {
                         window.history.back()
                    }, 400)
                }
            });


    }, []);

    const onCancelRequest = () => {
        API.cancelRequest(id)
            .then((response) => {
               toast.success(response.message)
                const params = {
                    'list' : 0
                }
                API.getRequest(id,params)
                    .then((response) => {
                        setRequest(response.data);
                        setIsLoaded(true)

                    })


            })
            .catch((error) => {
                setIsLoaded(true)
                if (error.response) {
                    toast.error(error.response.data.message);

                } else {
                    toast.error(error.message);

                }
            });
    }

    const GenerateContent = () => {
        if (!isLoaded) {
            return '';
        }
        const length = request?.package_info?.lengths;

        const width = request?.package_info?.width;
        const height = request?.package_info?.height;
        const weight = request?.package_info?.weight;
        const description = request?.package_info?.description;
        const parcelCount = Object.keys(weight)?.length;


        let rows = [];
        let tab = [];
        for (let i = 0; i < parcelCount; i++) {
            if (weight[i] > 0) {
                rows.push(
                    <tr>
                        <th scope="row">{i + 1}</th>
                        <td>{typeof length[i]  !== 'undefined' ? length[i] : ''}</td>
                        <td>{typeof width[i]  !== 'undefined' ? width[i] : ''}</td>
                        <td>{typeof height[i]  !== 'undefined' ? height[i] : ''}</td>
                        <td>{typeof weight[i]  !== 'undefined' ? weight[i] : ''}</td>
                        <td>{typeof description[i]  !== 'undefined' ? description[i] : ''}</td>
                    </tr>
                )
            }
        }
        tab.push(
            <table className="table table-striped mt-5 ">
                <thead>
                <tr>
                    <th scope="col" className='bg-secondary-subtle'>#</th>
                    <th scope="col" className='bg-secondary-subtle'>Length</th>
                    <th scope="col" className='bg-secondary-subtle'>Width</th>
                    <th scope="col" className='bg-secondary-subtle'>Height</th>
                    <th scope="col" className='bg-secondary-subtle'>Weight</th>
                    <th scope="col" className='bg-secondary-subtle'>Description</th>
                </tr>
                </thead>
                <tbody>

                {rows}

                </tbody>
                <tfoot >
                <tr>
                    <td colSpan='3' className='theme-bg text-white text-center fw-bold'>
                        Total Weight: &nbsp;
                        {request.total_weight}
                    </td>
                    <td colSpan='3' className='theme-bg text-white text-center fw-bold'>
                        Total Price: &nbsp;
                        ${request.total_price}
                        &nbsp;
                        CAD
                    </td>
                </tr>
                {request.extra_charge > 0 &&

                    <tr>
                        <td className='fw-bold text-muted'>
                            Extra Charge: ${request.extra_charge} CAD
                        </td>
                    </tr>
                }

                </tfoot>
            </table>
        )
        return (
            tab
        );

    }

    const onPayment = () => {
        setIsLoaded(false)
        const request = {
            'request_id' : id
        }
        API.payment(request)
            .then((response) => {

                toast.success(response.message);
                window.location.assign(response.url)

            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Header/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container mt-5 pt-4">
                <div className="row">
                    <div className="col-8">
                        <h3 className='theme-color fw-bold border-bottom pb-3'>
                            <span className='text-warning fw-bold'>C</span>heapShip


                        </h3>
                        <span style={{color: request.status?.color}}>
                            Status: &nbsp;
                                                    {request.status?.title}
                                                </span>
                        {request?.status?.id === 1 &&
                            <div className='alert alert-danger text-capitalize ' role='button'

                                 onClick={onPayment}
                            >
                                You have not yet paid the amount of this request. Click here to make payment
                                <FiExternalLink className='mx-2'/>
                            </div>
                        }
                        <div className='mt-4 text-small-1'>
                            <IoMdClock className='me-2 text-big-2'/>
                            Created Date: {request.date}
                        </div>
                        <div className='mt-2 text-small-1'>
                            <FaFileSignature className='me-2 text-big-2'/>
                            Need Signature: <b>{request.need_signature ? 'Yes' : 'No'}</b>
                        </div>
                        <div className='mt-2 text-small-1'>
                            <FaFileSignature className='me-2 text-big-2'/>
                            Parcel Type : <b>{request.is_document ? 'Document' : 'Package'}</b>
                        </div>
                        <div className='mt-2 text-small-1'>
                            <MdEmail className='me-2 text-big-2'/>

                            {request.from_address?.email}
                        </div>
                    </div>
                    <div className="col-4 mt-5 pt-3">
                        <div className="alert alert-secondary">
                            <div className='mt-2 text-small-1'>
                                <IoQrCodeOutline className='me-2 text-big-2'/>
                                {request.tracking_code}
                            </div>
                            <div className='mt-2 text-small-1'>
                                <HiMiniCalendarDateRange className='me-2 text-big-2'/>
                                Shipping Date: {request.shipping_date}
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <h4 className='text-success-emphasis fw-bold border-bottom pb-3 mt-4'>
                            Summery
                        </h4>
                    </div>
                    <div className="col-6">
                        <div className="fw-bold">
                            <ImLocation className='me-2 text-big-2'/>
                            From:

                        </div>

                        <div className='px-3'>

                            {request.from_address?.address1} -
                            {request.from_address?.address2} -
                            Unit/Floor: {request.from_address?.floor} <br/>
                            {request.from_address?.country} -
                            {request.from_address?.state} -
                            {request.from_address?.city} -
                            Postal Code: {request.from_address?.postalcode} -

                            <br/>
                            <strong>{request.from_address?.name}</strong> ,
                            <span className='px-2'>Phone: {request.from_address?.phone}</span>

                        </div>


                    </div>
                    <div className="col-6">
                        <div className="fw-bold">
                            <ImLocation className='me-2 text-big-2'/>
                            To:

                        </div>

                        <div className='px-3'>

                            {request.to_address?.address1} -
                            {request.to_address?.address2} -
                            Unit/Floor: {request.to_address?.floor} <br/>
                            {request.to_address?.country} -
                            {request.to_address?.state} -
                            {request.to_address?.city} -
                            Postal Code: {request.to_address?.postalcode} -

                            <br/>
                            <strong>{request.to_address?.name}</strong> ,
                            <span className='px-2'>Phone: {request.to_address?.phone}</span>
                        </div>

                    </div>
                    <div className="col-12">
                        {GenerateContent()}
                    </div>
                    <div className="col-12">
                        <b>Payment Records:</b>
                        {
                            request?.pay?.map((p, index) => {
                                return (
                                    <div className="row bg-light my-2 p-3">

                                        <div className="col-12">
                                            {index + 1} -
                                            <span className='text-success-emphasis mx-2 fw-bold'>${p.amount} CAD</span>
                                          ( On {p.created_at} )
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className="col-12 mt-5 no-print">
                    <button className="btn btn-outline-secondary no-print" onClick={() => {window.print()}}>Print</button>
                    {
                        request?.status?.id < 4 &&

                        <button className="btn btn-danger no-print mx-3" onClick={() => {
                            onCancelRequest()
                        }}>Cancel Request</button>
                    }

                </div>
            </section>
        </React.Fragment>
    );
};

export default Request;